import { zeosDialog } from '../../components/Shared/confirm-dialog/ConfirmDialog';
import { IPortfolioItem } from '../../mock-data/portfolioData';
import { IZeosApiService } from '../zeos-api/IZeosApiService';
import { PortfolioModalType } from './PortfolioHelpers';

export const isUtilityLinkAllowedState = (state?: string | null) => {
  const normalized = state?.trim().toLowerCase().replace(/[^a-z]/g, "");
  return normalized === "ny" ||
    normalized === "newyork" ||
    normalized === "nj" ||
    normalized === "newjersey";
};

export const handleOpenLinkUtilityAsync = async (
  property: IPortfolioItem,
  api: IZeosApiService
) => {
  const result = await api.Location.propertyLocationsAsync(property.propertyId);
  const locations = result.data;
  if (locations?.isNy || locations?.isNj) {
    return PortfolioModalType.UapiLink;
  }

  const propertyResponse = await api.Property.getProperty(property.propertyId);
  if (isUtilityLinkAllowedState(propertyResponse.data?.state)) {
    return PortfolioModalType.UapiLink;
  }

  zeosDialog(
    "Only properties in New York or New Jersey can be linked to a utility"
  );
  return PortfolioModalType.None;
};
